import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/contexts/AppContext";
import Layout from "@/components/Layout";
import InstallPrompt from "@/components/InstallPrompt";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Classes from "@/pages/Classes";
import ClassDetail from "@/pages/ClassDetail";
import SearchPage from "@/pages/Search";
import LODetail from "@/pages/LODetail";
import Bookmarks from "@/pages/Bookmarks";
import Analytics from "@/pages/Analytics";
import Admin from "@/pages/Admin";

function App() {
    return (
        <AppProvider>
            <BrowserRouter>
                <Layout>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/classes" element={<Classes />} />
                        <Route path="/classes/:classNum" element={<ClassDetail />} />
                        <Route path="/search" element={<SearchPage />} />
                        <Route path="/lo/:code" element={<LODetail />} />
                        <Route path="/bookmarks" element={<Bookmarks />} />
                        <Route path="/analytics" element={<Analytics />} />
                        <Route path="/admin" element={<Admin />} />
                    </Routes>
                </Layout>
                <InstallPrompt />
                <Toaster position="top-center" richColors closeButton />
            </BrowserRouter>
        </AppProvider>
    );
}

export default App;
